
document.addEventListener("DOMContentLoaded", function () {

  const sortSelect = document.getElementById("SortBy");
  const clearFiltersBtn = document.getElementById("ClearFilters");
  const mobileToggle = document.getElementById("MobileFilterToggle");
  const sidebar = document.getElementById("CollectionSidebar");
  const activeFiltersContainer = document.getElementById("ActiveFilters");
  const productsGrid = document.querySelector(".products-grid");
  const productCards = Array.from(document.querySelectorAll(".product-card"));
  const productCountEl = document.getElementById("ProductCount");
  const productCountLabel = document.getElementById("ProductCountLabel");
  const paginationEl = document.querySelector(".pagination");

  // Badge elements
  const ulCertDefault = document.getElementById("ul-cert-default");
  const ulCertEscooter = document.getElementById("ul-cert-escooter");
  const warrantyBadge = document.getElementById("warranty-badge");

  let activeFilters = {
    colors: [],
    sizes: [],
    types: [],
    vendors: [],
    materials: [],
    availability: false,
    priceRangeLabel: null,
    brands: [],
    styles: [],
    range: [],
    speed: [],
    capacity: [],
    weight: [],
    power: [],
    frametypes: [],
    priceMin: null,
    priceMax: null,
    producttypes: [],
  };

  function updateBadgeVisibility() {
    // Check if escooter is in the active product types
    const isEscooterSelected = activeFilters.producttypes?.some(
      (type) => type.toLowerCase() === 'escooter'
    );

    // Check if gotrax brand is selected (gotrax only sells escooters)
    const isGotraxSelected = activeFilters.brands?.some(
      (brand) => brand.toLowerCase() === 'gotrax'
    );

    // Show escooter badges if either escooter product type OR gotrax brand is selected
    if (isEscooterSelected || isGotraxSelected) {
      // Show escooter certification, hide default
      if (ulCertDefault) ulCertDefault.style.display = "none";
      if (ulCertEscooter) ulCertEscooter.style.display = "inline";
      
      // Hide warranty badge for escooters
      if (warrantyBadge) warrantyBadge.style.display = "none";
    } else {
      // Show default certification, hide escooter
      if (ulCertDefault) ulCertDefault.style.display = "inline";
      if (ulCertEscooter) ulCertEscooter.style.display = "none";
      
      // Show warranty badge for non-escooters
      if (warrantyBadge) warrantyBadge.style.display = "flex";
    }
  }

  
  function matchesRange(value, ranges) {
    if (!ranges.length) return true;
    return ranges.some((r) => value >= r.min && value <= r.max);
  }

  

  function countProductsForFilter(
    filterType,
    filterValue,
    isRange = false,
    rangeMin = null,
    rangeMax = null
  ) {
    let count = 0;

    productCards.forEach((card) => {
      // Create a temporary filter state with this specific filter active
      let tempShow = true;

      // Apply all currently active filters EXCEPT the one we're counting
      // This shows how many products would be visible if this filter was selected

      // Color filter
      if (activeFilters.colors.length && filterType !== "color") {
        if (
          !activeFilters.colors.some((c) =>
            card.dataset.productColors?.split(",").includes(c)
          )
        ) {
          tempShow = false;
        }
      }

      // Size filter
      if (activeFilters.sizes.length && filterType !== "size") {
        if (
          !activeFilters.sizes.some((s) =>
            card.dataset.productSizes?.split(",").includes(s)
          )
        ) {
          tempShow = false;
        }
      }

      // Product Type filter
      if (activeFilters.producttypes?.length && filterType !== "producttype") {
        if (!activeFilters.producttypes.includes(card.dataset.producttype)) {
          tempShow = false;
        }
      }

      // Brand filter
      if (activeFilters.brands?.length && filterType !== "brand") {
        if (!activeFilters.brands.includes(card.dataset.brand)) {
          tempShow = false;
        }
      }

      // Style filter
      if (activeFilters.styles?.length && filterType !== "style") {
        const productStyles =
          card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
          [];
        if (!activeFilters.styles.some((s) => productStyles.includes(s))) {
          tempShow = false;
        }
      }

      // Frame Type filter
      if (activeFilters.frametypes?.length && filterType !== "frametype") {
        if (!activeFilters.frametypes.includes(card.dataset.frametype)) {
          tempShow = false;
        }
      }

      // Range filters
      if (
        filterType !== "range" &&
        !matchesRange(+card.dataset.range, activeFilters.range || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "speed" &&
        !matchesRange(+card.dataset.speed, activeFilters.speed || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "capacity" &&
        !matchesRange(+card.dataset.capacity, activeFilters.capacity || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "weight" &&
        !matchesRange(+card.dataset.weight, activeFilters.weight || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "power" &&
        !matchesRange(+card.dataset.power, activeFilters.power || [])
      ) {
        tempShow = false;
      }

      // Price filter
      if (filterType !== "price") {
        const price = parseInt(card.dataset.productPrice);
        if (
          activeFilters.priceMin !== null &&
          activeFilters.priceMax !== null
        ) {
          if (
            price < activeFilters.priceMin ||
            price > activeFilters.priceMax
          ) {
            tempShow = false;
          }
        }
      }

      // Now check if this product matches the filter we're counting
      if (tempShow) {
        if (isRange) {
          const value = +card.dataset[filterType];
          if (value >= rangeMin && value <= rangeMax) {
            count++;
          }
        } else if (filterType === "price") {
          const price = parseInt(card.dataset.productPrice);
          if (price >= rangeMin && price <= rangeMax) {
            count++;
          }
        } else if (filterType === "style") {
          const productStyles =
            card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
            [];
          if (productStyles.includes(filterValue)) {
            count++;
          }
        } else {
          // Regular filter (brand, producttype, frametype, etc.)
          if (card.dataset[filterType] === filterValue) {
            count++;
          }
        }
      }
    });

    return count;
  }

  

  function updateFilterCounts() {
    // Update Brand counts
    document
      .querySelectorAll('input[data-filter="brand"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("brand", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        // Disable checkbox if count is 0
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Product Type counts
    document
      .querySelectorAll('input[data-filter="producttype"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("producttype", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Style counts
    document
      .querySelectorAll('input[data-filter="style"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("style", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Frame Type counts
    document
      .querySelectorAll('input[data-filter="frametype"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("frametype", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Range counts
    document
      .querySelectorAll('input[data-filter="range"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("range", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Speed counts
    document
      .querySelectorAll('input[data-filter="speed"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("speed", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Capacity counts
    document
      .querySelectorAll('input[data-filter="capacity"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("capacity", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Weight counts
    document
      .querySelectorAll('input[data-filter="weight"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("weight", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Power counts
    document
      .querySelectorAll('input[data-filter="power"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("power", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    // Update Price counts
    document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      const count = countProductsForFilter("price", null, false, min, max);
      const label = checkbox.nextElementSibling;
      const countSpan =
        label.querySelector(".filter-count") || document.createElement("span");
      countSpan.className = "filter-count";
      countSpan.textContent = ` (${count})`;
      if (!label.querySelector(".filter-count")) {
        label.appendChild(countSpan);
      }
      checkbox.disabled = count === 0;
      checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
    });
  }

  
  function initializeFilters() {
    const urlParams = new URLSearchParams(window.location.search);

    // Process all filter parameters from URL
    document
      .querySelectorAll('input[type="checkbox"][data-filter]')
      .forEach((checkbox) => {
        const filterType = checkbox.dataset.filter;
        const value = checkbox.value.toLowerCase();

        const param = urlParams.get(`filter_${filterType}`);
        if (param) {
          const valuesFromUrl = param
            .split(",")
            .map((v) => v.trim().toLowerCase());
          if (valuesFromUrl.includes(value)) {
            checkbox.checked = true;

            if (checkbox.dataset.min) {
              activeFilters[filterType] = activeFilters[filterType] || [];
              activeFilters[filterType].push({
                min: parseInt(checkbox.dataset.min),
                max: parseInt(checkbox.dataset.max),
              });
            } else {
              const filterKey = filterType + "s";
              activeFilters[filterKey] = activeFilters[filterKey] || [];
              if (!activeFilters[filterKey].includes(value)) {
                activeFilters[filterKey].push(value);
              }
            }
          }
        }
      });

    // Handle price filters from URL
    const min = urlParams.get("price_min");
    const max = urlParams.get("price_max");
    if (min) activeFilters.priceMin = parseInt(min);
    if (max) activeFilters.priceMax = parseInt(max);

    applyClientSideFilters();
    updateActiveFilterDisplay();
    updateFilterCounts();
    updateBadgeVisibility();
  }

  
  function updateURL() {
    const params = new URLSearchParams();

    // Build filter parameters
    Object.entries(activeFilters).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        // Handle range filters
        if (
          values[0] &&
          typeof values[0] === "object" &&
          values[0].min !== undefined
        ) {
          // For range filters, we don't add to URL (too complex)
          return;
        }

        // Remove trailing 's' from key to get filter type
        const filterType = key.endsWith("s") ? key.slice(0, -1) : key;
        params.set(`filter_${filterType}`, values.join(","));
      }
    });

    // Add price filters
    if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
      params.set("price_min", activeFilters.priceMin);
      params.set("price_max", activeFilters.priceMax);
    }

    // Update URL without page reload
    const newURL = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;

    window.history.pushState({}, "", newURL);
  }

  

  document
    .querySelectorAll('input[type="checkbox"][data-filter]')
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const key = this.dataset.filter;

        if (this.dataset.min) {
          activeFilters[key] = activeFilters[key] || [];
          if (this.checked) {
            activeFilters[key].push({
              min: parseInt(this.dataset.min),
              max: parseInt(this.dataset.max),
            });
          } else {
            activeFilters[key] = activeFilters[key].filter(
              (r) => r.min != this.dataset.min
            );
          }
        } else {
          const filterKey = key + "s";
          const value = this.value;

          if (!activeFilters[filterKey]) {
            activeFilters[filterKey] = [];
          }

          if (this.checked) {
            if (!activeFilters[filterKey].includes(value)) {
              activeFilters[filterKey].push(value);
            }
          } else {
            activeFilters[filterKey] = activeFilters[filterKey].filter(
              (v) => v !== value
            );
          }
        }

        applyClientSideFilters();
        updateActiveFilterDisplay();
        updateFilterCounts();
        updateURL(); // Add URL update
        updateBadgeVisibility(); // Update badges on init
      });
    });

  

  document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const min = parseInt(this.dataset.min);
      const max = parseInt(this.dataset.max);
      const label = this.nextElementSibling.cloneNode(true);
      label.querySelector(".filter-count")?.remove();
      const labelText = label.textContent.trim();

      if (this.checked) {
        document.querySelectorAll(".price-range-filter").forEach((cb) => {
          if (cb !== this) cb.checked = false;
        });

        activeFilters.priceMin = min;
        activeFilters.priceMax = max;
        activeFilters.priceRangeLabel = labelText;
      } else {
        activeFilters.priceMin = null;
        activeFilters.priceMax = null;
        activeFilters.priceRangeLabel = null;
      }

      applyClientSideFilters();
      updateActiveFilterDisplay();
      updateFilterCounts();
      updateURL(); // Add URL update
      updateBadgeVisibility(); // Update badges on init
    });
  });

  

  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      sortVisibleProducts(this.value);
    });
  }

  function sortVisibleProducts(sortBy) {
    const visibleProducts = productCards.filter(
      (card) => card.style.display !== "none"
    );

    let sorted;

    switch (sortBy) {
      case "price-ascending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice)
        );
        break;

      case "price-descending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice)
        );
        break;

      case "title-ascending":
        sorted = visibleProducts.sort((a, b) =>
          a.dataset.productTitle.localeCompare(b.dataset.productTitle)
        );
        break;

      case "title-descending":
        sorted = visibleProducts.sort((a, b) =>
          b.dataset.productTitle.localeCompare(a.dataset.productTitle)
        );
        break;

      case "created-descending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(b.dataset.productCreated) -
            parseInt(a.dataset.productCreated)
        );
        break;

      default:
        return;
    }

    sorted.forEach((card) => productsGrid.appendChild(card));
  }

  

  function applyClientSideFilters() {
    let visibleCount = 0;
    const productsPerPage = 200;

    productCards.forEach((card) => {
      let show = true;

      if (
        activeFilters.colors.length &&
        !activeFilters.colors.some((c) =>
          card.dataset.productColors?.split(",").includes(c)
        )
      )
        show = false;

      if (
        activeFilters.sizes.length &&
        !activeFilters.sizes.some((s) =>
          card.dataset.productSizes?.split(",").includes(s)
        )
      )
        show = false;

      if (
        activeFilters.producttypes?.length &&
        !activeFilters.producttypes.includes(card.dataset.producttype)
      )
        show = false;

      if (
        activeFilters.vendors.length &&
        !activeFilters.vendors.includes(card.dataset.productVendor)
      )
        show = false;

      if (
        activeFilters.brands?.length &&
        !activeFilters.brands.includes(card.dataset.brand)
      )
        show = false;

      if (activeFilters.styles?.length) {
        const productStyles =
          card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
          [];
        if (!activeFilters.styles.some((s) => productStyles.includes(s)))
          show = false;
      }

      if (
        activeFilters.frametypes?.length &&
        !activeFilters.frametypes.includes(card.dataset.frametype)
      )
        show = false;

      if (!matchesRange(+card.dataset.range, activeFilters.range || []))
        show = false;

      if (!matchesRange(+card.dataset.speed, activeFilters.speed || []))
        show = false;

      if (!matchesRange(+card.dataset.capacity, activeFilters.capacity || []))
        show = false;

      if (!matchesRange(+card.dataset.weight, activeFilters.weight || []))
        show = false;

      if (!matchesRange(+card.dataset.power, activeFilters.power || []))
        show = false;

      const price = parseInt(card.dataset.productPrice);
      if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
        if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
          show = false;
        }
      }

      card.style.display = show ? "" : "none";
    if (show) visibleCount++;
  });

  // --- Brand grouping + Urtopia pinning ---
  const PINNED_TITLES = ["joy carbon", "carbon joy ultra"];
  const PRIORITY_BRAND = "urtopia";

  const visibleCards = productCards.filter(c => c.style.display !== "none");

  // Separate Urtopia from all other brands
  const urtopiaCards = visibleCards.filter(c => (c.dataset.brand || "").toLowerCase() === PRIORITY_BRAND);
  const otherCards = visibleCards.filter(c => (c.dataset.brand || "").toLowerCase() !== PRIORITY_BRAND);

  // Within Urtopia: pinned products first, then the rest
  const urtopiaOrdered = [
    ...["joy carbon", "carbon joy ultra"]
      .map(title => urtopiaCards.find(c => (c.dataset.productTitle || "").toLowerCase().trim() === title))
      .filter(Boolean),
    ...urtopiaCards.filter(c => !PINNED_TITLES.includes((c.dataset.productTitle || "").toLowerCase().trim()))
  ];

  // Group other brands: keep each brand's products together, preserving original order
  const brandOrder = [];
  const brandGroups = {};
  otherCards.forEach(c => {
    const brand = (c.dataset.brand || "").toLowerCase();
    if (!brandGroups[brand]) {
      brandGroups[brand] = [];
      brandOrder.push(brand);
    }
    brandGroups[brand].push(c);
  });

  const otherOrdered = brandOrder.flatMap(brand => brandGroups[brand]);

  // Final order: Urtopia first (if present), then other brands grouped
  [...urtopiaOrdered, ...otherOrdered].forEach(card => productsGrid.appendChild(card));
  // --- end brand grouping ---

  if (productCountEl) {
    productCountEl.textContent = visibleCount;
    productCountLabel.textContent =
      visibleCount === 1 ? "product" : "products";
  }

  if (paginationEl) {
    paginationEl.style.display =
      visibleCount <= productsPerPage ? "none" : "";
  }
}

  

  function updateActiveFilterDisplay() {
    const list = activeFiltersContainer.querySelector(".active-filters-list");
    list.innerHTML = "";

    if (activeFilters.priceRangeLabel) {
      const tag = document.createElement("span");
      tag.className = "filter-tag";
      tag.innerHTML = `${activeFilters.priceRangeLabel} <button data-filter-type="price">×</button>`;
      list.appendChild(tag);
    }

    Object.entries(activeFilters).forEach(([key, values]) => {
      if (!Array.isArray(values)) return;

      values.forEach((val) => {
        const tag = document.createElement("span");
        tag.className = "filter-tag";

        if (typeof val === "object" && val.min !== undefined) {
          tag.innerHTML = `${key}: ${val.min}-${val.max} <button data-k="${key}" data-min="${val.min}">×</button>`;
        } else {
          tag.innerHTML = `${val} <button data-k="${key}" data-v="${val}">×</button>`;
        }

        list.appendChild(tag);
      });
    });

    list.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.dataset.filterType === "price") {
          activeFilters.priceMin = null;
          activeFilters.priceMax = null;
          activeFilters.priceRangeLabel = null;
          document.querySelectorAll(".price-range-filter").forEach((cb) => {
            cb.checked = false;
          });
        } else if (btn.dataset.min) {
          const key = btn.dataset.k;
          const min = btn.dataset.min;
          activeFilters[key] = activeFilters[key].filter((r) => r.min != min);

          const checkbox = document.querySelector(
            `input[data-filter="${key}"][data-min="${min}"]`
          );
          if (checkbox) checkbox.checked = false;
        } else {
          const key = btn.dataset.k;
          const val = btn.dataset.v;
          activeFilters[key] = activeFilters[key].filter((v) => v !== val);

          const checkbox = document.querySelector(`input[value="${val}"]`);
          if (checkbox) checkbox.checked = false;
        }

        applyClientSideFilters();
        updateActiveFilterDisplay();
        updateFilterCounts();
        updateURL(); // Add URL update
        updateBadgeVisibility(); // Update badges on init
      });
    });

    activeFiltersContainer.style.display = list.children.length
      ? "block"
      : "none";
  }

  

  const filterOverlay = document.createElement("div");
  filterOverlay.className = "filter-overlay";
  filterOverlay.id = "FilterOverlay";
  document.body.appendChild(filterOverlay);

  const mobileCloseBtn = document.getElementById("MobileFilterClose");

  function openMobileSidebar() {
    sidebar.classList.add("active");
    document.body.classList.add("filter-open");
    filterOverlay.classList.add("active");
  }

  function closeMobileSidebar() {
    sidebar.classList.remove("active");
    document.body.classList.remove("filter-open");
    filterOverlay.classList.remove("active");
  }

  if (mobileToggle && sidebar) {
    mobileToggle.addEventListener("click", openMobileSidebar);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener("click", closeMobileSidebar);
  }

  filterOverlay.addEventListener("click", closeMobileSidebar);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sidebar.classList.contains("active")) {
      closeMobileSidebar();
    }
  });

  

  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", () => {
      Object.keys(activeFilters).forEach((k) => {
        if (Array.isArray(activeFilters[k])) {
          activeFilters[k] = [];
        } else {
          activeFilters[k] = null;
        }
      });

      document
        .querySelectorAll('input[type="checkbox"]')
        .forEach((c) => (c.checked = false));

      applyClientSideFilters();
      updateActiveFilterDisplay();
      updateFilterCounts();
      updateURL(); // Add URL update
      updateBadgeVisibility(); // Update badges on init
    });
  }

  

  initializeFilters();
});


/*
document.addEventListener("DOMContentLoaded", function () {
  const sortSelect = document.getElementById("SortBy");
  const clearFiltersBtn = document.getElementById("ClearFilters");
  const mobileToggle = document.getElementById("MobileFilterToggle");
  const sidebar = document.getElementById("CollectionSidebar");
  const activeFiltersContainer = document.getElementById("ActiveFilters");
  const productsGrid = document.querySelector(".products-grid");
  const productCards = Array.from(document.querySelectorAll(".product-card"));
  const productCountEl = document.getElementById("ProductCount");
  const productCountLabel = document.getElementById("ProductCountLabel");
  const paginationEl = document.querySelector(".pagination");

  // Badge elements
  const ulCertDefault = document.getElementById("ul-cert-default");
  const ulCertEscooter = document.getElementById("ul-cert-escooter");
  const warrantyBadge = document.getElementById("warranty-badge");

  
  let activeFilters = {
    colors: [],
    sizes: [],
    types: [],
    vendors: [],
    materials: [],
    availability: false,
    priceRangeLabel: null,
    brands: [],
    styles: [],
    range: [],
    speed: [],
    capacity: [],
    weight: [],
    power: [],
    frametypes: [],
    priceMin: null,
    priceMax: null,
    producttypes: [],
  };

  
  function updateBadgeVisibility() {
    // Check if escooter is in the active product types
    const isEscooterSelected = activeFilters.producttypes?.some(
      (type) => type.toLowerCase() === 'escooter'
    );

    // Check if gotrax brand is selected (gotrax only sells escooters)
    const isGotraxSelected = activeFilters.brands?.some(
      (brand) => brand.toLowerCase() === 'gotrax'
    );

    // Show escooter badges if either escooter product type OR gotrax brand is selected
    if (isEscooterSelected || isGotraxSelected) {
      // Show escooter certification, hide default
      if (ulCertDefault) ulCertDefault.style.display = "none";
      if (ulCertEscooter) ulCertEscooter.style.display = "inline";
      
      // Hide warranty badge for escooters
      if (warrantyBadge) warrantyBadge.style.display = "none";
    } else {
      // Show default certification, hide escooter
      if (ulCertDefault) ulCertDefault.style.display = "inline";
      if (ulCertEscooter) ulCertEscooter.style.display = "none";
      
      // Show warranty badge for non-escooters
      if (warrantyBadge) warrantyBadge.style.display = "flex";
    }
  }

  
  function matchesRange(value, ranges) {
    if (!ranges || ranges.length === 0) return true;
    return ranges.some((r) => value >= r.min && value <= r.max);
  }

  
  function countProductsForFilter(filterType, filterValue, isRange = false, rangeMin = null, rangeMax = null) {
    let count = 0;

    productCards.forEach((card) => {
      let wouldShow = true;

      // Apply all currently active filters EXCEPT the one we're counting
      
      // Color filter
      if (activeFilters.colors.length && filterType !== "color") {
        const productColors = (card.dataset.productColors || "").split(",").map(c => c.trim().toLowerCase());
        if (!activeFilters.colors.some((c) => productColors.includes(c.toLowerCase()))) {
          wouldShow = false;
        }
      }

      // Size filter
      if (activeFilters.sizes.length && filterType !== "size") {
        const productSizes = (card.dataset.productSizes || "").split(",").map(s => s.trim().toLowerCase());
        if (!activeFilters.sizes.some((s) => productSizes.includes(s.toLowerCase()))) {
          wouldShow = false;
        }
      }

      // Product Type filter
      if (activeFilters.producttypes?.length && filterType !== "producttype") {
        if (!activeFilters.producttypes.includes((card.dataset.producttype || "").toLowerCase())) {
          wouldShow = false;
        }
      }

      // Brand filter
      if (activeFilters.brands?.length && filterType !== "brand") {
        if (!activeFilters.brands.includes((card.dataset.brand || "").toLowerCase())) {
          wouldShow = false;
        }
      }

      // Style filter
      if (activeFilters.styles?.length && filterType !== "style") {
        const productStyles = (card.dataset.style || "").split(",").map((s) => s.trim().toLowerCase());
        if (!activeFilters.styles.some((s) => productStyles.includes(s))) {
          wouldShow = false;
        }
      }

      // Frame Type filter
      if (activeFilters.frametypes?.length && filterType !== "frametype") {
        if (!activeFilters.frametypes.includes((card.dataset.frametype || "").toLowerCase())) {
          wouldShow = false;
        }
      }

      // Range filters (only apply if we're not counting this specific range type)
      if (filterType !== "range" && !matchesRange(parseFloat(card.dataset.range) || 0, activeFilters.range || [])) {
        wouldShow = false;
      }

      if (filterType !== "speed" && !matchesRange(parseFloat(card.dataset.speed) || 0, activeFilters.speed || [])) {
        wouldShow = false;
      }

      if (filterType !== "capacity" && !matchesRange(parseFloat(card.dataset.capacity) || 0, activeFilters.capacity || [])) {
        wouldShow = false;
      }

      if (filterType !== "weight" && !matchesRange(parseFloat(card.dataset.weight) || 0, activeFilters.weight || [])) {
        wouldShow = false;
      }

      if (filterType !== "power" && !matchesRange(parseFloat(card.dataset.power) || 0, activeFilters.power || [])) {
        wouldShow = false;
      }

      // Price filter
      if (filterType !== "price") {
        const price = parseInt(card.dataset.productPrice) || 0;
        if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
          if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
            wouldShow = false;
          }
        }
      }

      // Now check if this product matches the filter we're counting
      if (wouldShow) {
        if (isRange) {
          const value = parseFloat(card.dataset[filterType]) || 0;
          if (value >= rangeMin && value <= rangeMax) {
            count++;
          }
        } else if (filterType === "price") {
          const price = parseInt(card.dataset.productPrice) || 0;
          if (price >= rangeMin && price <= rangeMax) {
            count++;
          }
        } else if (filterType === "style") {
          const productStyles = (card.dataset.style || "").split(",").map((s) => s.trim().toLowerCase());
          if (productStyles.includes(filterValue.toLowerCase())) {
            count++;
          }
        } else if (filterType === "color") {
          const productColors = (card.dataset.productColors || "").split(",").map(c => c.trim().toLowerCase());
          if (productColors.includes(filterValue.toLowerCase())) {
            count++;
          }
        } else if (filterType === "size") {
          const productSizes = (card.dataset.productSizes || "").split(",").map(s => s.trim().toLowerCase());
          if (productSizes.includes(filterValue.toLowerCase())) {
            count++;
          }
        } else {
          // Regular filter (brand, producttype, frametype, etc.)
          if ((card.dataset[filterType] || "").toLowerCase() === filterValue.toLowerCase()) {
            count++;
          }
        }
      }
    });

    return count;
  }

  
  function updateFilterCounts() {
    // Helper function to update a single filter checkbox
    const updateCheckboxCount = (checkbox, filterType, value = null, isRange = false, min = null, max = null) => {
      const count = isRange 
        ? countProductsForFilter(filterType, null, true, min, max)
        : countProductsForFilter(filterType, value);
      
      const label = checkbox.nextElementSibling;
      if (!label) return;
      
      // Remove existing count span
      const existingCount = label.querySelector(".filter-count");
      if (existingCount) {
        existingCount.remove();
      }
      
      // Add new count span
      const countSpan = document.createElement("span");
      countSpan.className = "filter-count";
      countSpan.textContent = ` (${count})`;
      label.appendChild(countSpan);
      
      // Disable checkbox if count is 0
      checkbox.disabled = count === 0;
      checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      checkbox.parentElement.style.pointerEvents = count === 0 ? "none" : "auto";
    };

    // Update Brand counts
    document.querySelectorAll('input[data-filter="brand"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "brand", checkbox.value);
    });

    // Update Product Type counts
    document.querySelectorAll('input[data-filter="producttype"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "producttype", checkbox.value);
    });

    // Update Style counts
    document.querySelectorAll('input[data-filter="style"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "style", checkbox.value);
    });

    // Update Frame Type counts
    document.querySelectorAll('input[data-filter="frametype"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "frametype", checkbox.value);
    });

    // Update Color counts
    document.querySelectorAll('input[data-filter="color"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "color", checkbox.value);
    });

    // Update Size counts
    document.querySelectorAll('input[data-filter="size"]').forEach((checkbox) => {
      updateCheckboxCount(checkbox, "size", checkbox.value);
    });

    // Update Range counts
    document.querySelectorAll('input[data-filter="range"]').forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "range", null, true, min, max);
    });

    // Update Speed counts
    document.querySelectorAll('input[data-filter="speed"]').forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "speed", null, true, min, max);
    });

    // Update Capacity counts
    document.querySelectorAll('input[data-filter="capacity"]').forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "capacity", null, true, min, max);
    });

    // Update Weight counts
    document.querySelectorAll('input[data-filter="weight"]').forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "weight", null, true, min, max);
    });

    // Update Power counts
    document.querySelectorAll('input[data-filter="power"]').forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "power", null, true, min, max);
    });

    // Update Price counts
    document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      updateCheckboxCount(checkbox, "price", null, false, min, max);
    });
  }

  
  function initializeFilters() {
    const urlParams = new URLSearchParams(window.location.search);

    // Process all filter parameters from URL
    document.querySelectorAll('input[type="checkbox"][data-filter]').forEach((checkbox) => {
      const filterType = checkbox.dataset.filter;
      const value = (checkbox.value || "").toLowerCase();

      const param = urlParams.get(`filter_${filterType}`);
      if (param) {
        const valuesFromUrl = param.split(",").map((v) => v.trim().toLowerCase());
        if (valuesFromUrl.includes(value)) {
          checkbox.checked = true;

          if (checkbox.dataset.min) {
            // Range filter
            activeFilters[filterType] = activeFilters[filterType] || [];
            activeFilters[filterType].push({
              min: parseInt(checkbox.dataset.min),
              max: parseInt(checkbox.dataset.max),
            });
          } else {
            // Regular filter
            const filterKey = filterType + "s";
            activeFilters[filterKey] = activeFilters[filterKey] || [];
            if (!activeFilters[filterKey].includes(value)) {
              activeFilters[filterKey].push(value);
            }
          }
        }
      }
    });

    // Handle price filters from URL
    const min = urlParams.get("price_min");
    const max = urlParams.get("price_max");
    if (min) activeFilters.priceMin = parseInt(min);
    if (max) activeFilters.priceMax = parseInt(max);

    applyClientSideFilters();
    updateActiveFilterDisplay();
    updateFilterCounts();
    updateBadgeVisibility(); // Update badges on init
  }

  
  function updateURL() {
    const params = new URLSearchParams();

    // Build filter parameters
    Object.entries(activeFilters).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        // Handle range filters - skip them for URL (too complex)
        if (values[0] && typeof values[0] === "object" && values[0].min !== undefined) {
          return;
        }

        // Remove trailing 's' from key to get filter type
        const filterType = key.endsWith("s") ? key.slice(0, -1) : key;
        params.set(`filter_${filterType}`, values.join(","));
      }
    });

    // Add price filters
    if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
      params.set("price_min", activeFilters.priceMin);
      params.set("price_max", activeFilters.priceMax);
    }

    // Update URL without page reload
    const newURL = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;

    window.history.pushState({}, "", newURL);
  }

  
  document.querySelectorAll('input[type="checkbox"][data-filter]').forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const key = this.dataset.filter;
      const value = (this.value || "").toLowerCase();

      if (this.dataset.min) {
        // Range filter
        activeFilters[key] = activeFilters[key] || [];
        if (this.checked) {
          activeFilters[key].push({
            min: parseInt(this.dataset.min),
            max: parseInt(this.dataset.max),
          });
        } else {
          activeFilters[key] = activeFilters[key].filter(
            (r) => r.min != this.dataset.min
          );
        }
      } else {
        // Regular filter
        const filterKey = key + "s";
        
        if (!activeFilters[filterKey]) {
          activeFilters[filterKey] = [];
        }

        if (this.checked) {
          if (!activeFilters[filterKey].includes(value)) {
            activeFilters[filterKey].push(value);
          }
        } else {
          activeFilters[filterKey] = activeFilters[filterKey].filter(
            (v) => v !== value
          );
        }
      }

      applyClientSideFilters();
      updateActiveFilterDisplay();
      updateFilterCounts();
      updateURL();
      updateBadgeVisibility(); // Update badges when filters change
    });
  });

  
  document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const min = parseInt(this.dataset.min);
      const max = parseInt(this.dataset.max);
      const label = this.nextElementSibling.cloneNode(true);
      label.querySelector(".filter-count")?.remove();
      const labelText = label.textContent.trim();

      if (this.checked) {
        // Uncheck other price filters (only one can be active)
        document.querySelectorAll(".price-range-filter").forEach((cb) => {
          if (cb !== this) cb.checked = false;
        });

        activeFilters.priceMin = min;
        activeFilters.priceMax = max;
        activeFilters.priceRangeLabel = labelText;
      } else {
        activeFilters.priceMin = null;
        activeFilters.priceMax = null;
        activeFilters.priceRangeLabel = null;
      }

      applyClientSideFilters();
      updateActiveFilterDisplay();
      updateFilterCounts();
      updateURL();
      updateBadgeVisibility(); // Update badges when price filter changes
    });
  });

  
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      sortVisibleProducts(this.value);
    });
  }

  function sortVisibleProducts(sortBy) {
    const visibleProducts = productCards.filter(
      (card) => card.style.display !== "none"
    );

    let sorted;

    switch (sortBy) {
      case "price-ascending":
        sorted = visibleProducts.sort(
          (a, b) => parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice)
        );
        break;

      case "price-descending":
        sorted = visibleProducts.sort(
          (a, b) => parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice)
        );
        break;

      case "title-ascending":
        sorted = visibleProducts.sort((a, b) =>
          a.dataset.productTitle.localeCompare(b.dataset.productTitle)
        );
        break;

      case "title-descending":
        sorted = visibleProducts.sort((a, b) =>
          b.dataset.productTitle.localeCompare(a.dataset.productTitle)
        );
        break;

      case "created-descending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(b.dataset.productCreated) - parseInt(a.dataset.productCreated)
        );
        break;

      default:
        return;
    }

    sorted.forEach((card) => productsGrid.appendChild(card));
  }

  
  function applyClientSideFilters() {
    let visibleCount = 0;
    const productsPerPage = 200;

    productCards.forEach((card) => {
      let show = true;

      // Color filter
      if (activeFilters.colors.length) {
        const productColors = (card.dataset.productColors || "").split(",").map(c => c.trim().toLowerCase());
        if (!activeFilters.colors.some((c) => productColors.includes(c.toLowerCase()))) {
          show = false;
        }
      }

      // Size filter
      if (activeFilters.sizes.length) {
        const productSizes = (card.dataset.productSizes || "").split(",").map(s => s.trim().toLowerCase());
        if (!activeFilters.sizes.some((s) => productSizes.includes(s.toLowerCase()))) {
          show = false;
        }
      }

      // Product Type filter
      if (activeFilters.producttypes?.length) {
        if (!activeFilters.producttypes.includes((card.dataset.producttype || "").toLowerCase())) {
          show = false;
        }
      }

      // Vendor filter
      if (activeFilters.vendors?.length) {
        if (!activeFilters.vendors.includes((card.dataset.productVendor || "").toLowerCase())) {
          show = false;
        }
      }

      // Brand filter
      if (activeFilters.brands?.length) {
        if (!activeFilters.brands.includes((card.dataset.brand || "").toLowerCase())) {
          show = false;
        }
      }

      // Style filter
      if (activeFilters.styles?.length) {
        const productStyles = (card.dataset.style || "").split(",").map((s) => s.trim().toLowerCase());
        if (!activeFilters.styles.some((s) => productStyles.includes(s))) {
          show = false;
        }
      }

      // Frame Type filter
      if (activeFilters.frametypes?.length) {
        if (!activeFilters.frametypes.includes((card.dataset.frametype || "").toLowerCase())) {
          show = false;
        }
      }

      // Range filters
      if (!matchesRange(parseFloat(card.dataset.range) || 0, activeFilters.range || [])) {
        show = false;
      }

      if (!matchesRange(parseFloat(card.dataset.speed) || 0, activeFilters.speed || [])) {
        show = false;
      }

      if (!matchesRange(parseFloat(card.dataset.capacity) || 0, activeFilters.capacity || [])) {
        show = false;
      }

      if (!matchesRange(parseFloat(card.dataset.weight) || 0, activeFilters.weight || [])) {
        show = false;
      }

      if (!matchesRange(parseFloat(card.dataset.power) || 0, activeFilters.power || [])) {
        show = false;
      }

      // Price filter
      const price = parseInt(card.dataset.productPrice) || 0;
      if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
        if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
          show = false;
        }
      }

      card.style.display = show ? "" : "none";
      if (show) visibleCount++;
    });

    // Update product count
    if (productCountEl) {
      productCountEl.textContent = visibleCount;
    }
    if (productCountLabel) {
      productCountLabel.textContent = visibleCount === 1 ? "product" : "products";
    }

    // Show/hide pagination
    if (paginationEl) {
      paginationEl.style.display = visibleCount <= productsPerPage ? "none" : "";
    }
  }

  
  function updateActiveFilterDisplay() {
    const list = activeFiltersContainer.querySelector(".active-filters-list");
    if (!list) return;
    
    list.innerHTML = "";

    // Show price filter tag
    if (activeFilters.priceRangeLabel) {
      const tag = document.createElement("span");
      tag.className = "filter-tag";
      tag.innerHTML = `${activeFilters.priceRangeLabel} <button data-filter-type="price">×</button>`;
      list.appendChild(tag);
    }

    // Show all other filter tags
    Object.entries(activeFilters).forEach(([key, values]) => {
      if (!Array.isArray(values)) return;

      values.forEach((val) => {
        const tag = document.createElement("span");
        tag.className = "filter-tag";

        if (typeof val === "object" && val.min !== undefined) {
          // Range filter tag
          tag.innerHTML = `${key}: ${val.min}-${val.max} <button data-k="${key}" data-min="${val.min}">×</button>`;
        } else {
          // Regular filter tag
          tag.innerHTML = `${val} <button data-k="${key}" data-v="${val}">×</button>`;
        }

        list.appendChild(tag);
      });
    });

    // Add click handlers to remove filter tags
    list.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.dataset.filterType === "price") {
          // Remove price filter
          activeFilters.priceMin = null;
          activeFilters.priceMax = null;
          activeFilters.priceRangeLabel = null;
          document.querySelectorAll(".price-range-filter").forEach((cb) => {
            cb.checked = false;
          });
        } else if (btn.dataset.min) {
          // Remove range filter
          const key = btn.dataset.k;
          const min = btn.dataset.min;
          activeFilters[key] = activeFilters[key].filter((r) => r.min != min);

          const checkbox = document.querySelector(
            `input[data-filter="${key}"][data-min="${min}"]`
          );
          if (checkbox) checkbox.checked = false;
        } else {
          // Remove regular filter
          const key = btn.dataset.k;
          const val = btn.dataset.v;
          activeFilters[key] = activeFilters[key].filter((v) => v !== val);

          const checkbox = document.querySelector(
            `input[data-filter="${key.slice(0, -1)}"][value="${val}"]`
          );
          if (checkbox) checkbox.checked = false;
        }

        applyClientSideFilters();
        updateActiveFilterDisplay();
        updateFilterCounts();
        updateURL();
        updateBadgeVisibility(); // Update badges when removing filters
      });
    });

    // Show/hide active filters container
    if (activeFiltersContainer) {
      activeFiltersContainer.style.display = list.children.length ? "block" : "none";
    }
  }

  
  const filterOverlay = document.createElement("div");
  filterOverlay.className = "filter-overlay";
  filterOverlay.id = "FilterOverlay";
  document.body.appendChild(filterOverlay);

  const mobileCloseBtn = document.getElementById("MobileFilterClose");

  function openMobileSidebar() {
    if (sidebar) {
      sidebar.classList.add("active");
      document.body.classList.add("filter-open");
      filterOverlay.classList.add("active");
    }
  }

  function closeMobileSidebar() {
    if (sidebar) {
      sidebar.classList.remove("active");
      document.body.classList.remove("filter-open");
      filterOverlay.classList.remove("active");
    }
  }

  if (mobileToggle && sidebar) {
    mobileToggle.addEventListener("click", openMobileSidebar);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener("click", closeMobileSidebar);
  }

  filterOverlay.addEventListener("click", closeMobileSidebar);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sidebar && sidebar.classList.contains("active")) {
      closeMobileSidebar();
    }
  });

  
  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", () => {
      // Reset all filters
      Object.keys(activeFilters).forEach((k) => {
        if (Array.isArray(activeFilters[k])) {
          activeFilters[k] = [];
        } else {
          activeFilters[k] = null;
        }
      });

      // Uncheck all checkboxes
      document.querySelectorAll('input[type="checkbox"]').forEach((c) => (c.checked = false));

      applyClientSideFilters();
      updateActiveFilterDisplay();
      updateFilterCounts();
      updateURL();
      updateBadgeVisibility(); // Update badges when clearing filters
    });
  }

  
  initializeFilters();
});
*/
